import { render } from "./ReceivablesPage.vue?vue&type=template&id=3ef44636&scoped=true"
import script from "./ReceivablesPage.vue?vue&type=script&lang=js"
export * from "./ReceivablesPage.vue?vue&type=script&lang=js"

import "./ReceivablesPage.vue?vue&type=style&index=0&id=3ef44636&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef44636"]])

export default __exports__